import { useBreakpoint } from '@landr/maestro';
import { getIsDAWPlugin } from 'helpers/executionEnvironment';
import {
    UnbHeightPx,
    NavHeightPxDesktop,
    NavHeightPxMobile,
} from '../../constants';

// TO BE RENAMED
const useAppNavigationMeta = () => {
    const isMobileNav = useBreakpoint('md');

    const isDAWPlugin = getIsDAWPlugin();
    const isUnbAllowed = !isDAWPlugin;

    const unbHeight = isUnbAllowed ? UnbHeightPx : 0;
    const desktopNavHeight = NavHeightPxDesktop;
    const mobileNavHeight = NavHeightPxMobile;

    const responsiveNavHeight = isMobileNav
        ? mobileNavHeight
        : desktopNavHeight;

    const responsiveUnbAndNavHeight = unbHeight + responsiveNavHeight;
    const desktopUnbAndNavHeight = unbHeight + desktopNavHeight;
    const mobileUnbAndNavHeight = unbHeight + mobileNavHeight;

    return {
        unbHeight,
        responsiveNavHeight,
        desktopNavHeight,
        mobileNavHeight,
        responsiveUnbAndNavHeight,
        desktopUnbAndNavHeight,
        mobileUnbAndNavHeight,
        isUnbAllowed,
    };
};

export default useAppNavigationMeta;
